/* Amara, universalsubtitles.org
 *
 * Copyright (C) 2017 Participatory Culture Foundation
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see
 * http://www.gnu.org/licenses/agpl-3.0.html.
 */

var $ = require('jquery');
var cookies = require('browser-cookies');

$.behaviors('.tabs > a, .tabSwitcher', function(elt) {
    var tabSwitcher = $(elt);
    tabSwitcher.on('click', function() {
        var targetId = tabSwitcher.attr('href') || tabSwitcher.data('target');
        if(targetId) {
            var target = $(targetId);
            if(target) {
                var rv = tabSwitcher.triggerHandler('tab-activate', target);
                if(rv !== false) {
                    activateTab(tabSwitcher, target);
                    return false;
                }
            }
        }
    });

});

$.behaviors('.tabs[data-persist]', function(elt) {
    elt = $(elt)
    elt.children('a').on('tab-activate', function(evt, tab) {
        var name = elt.data('persist');
        var id = $(tab).attr('id');
        if(name && id) {
            cookies.set(name, id);
        }
    });

    var currentValue = cookies.get(elt.data('persist'));
    if(currentValue) {
        var activeTab = $('#' + currentValue);
        if(activeTab.length) {
            tabSwitcher = elt.children('[href="#' + currentValue + '"], [data-target="#' + currentValue + '"]');
            if(tabSwitcher.length == 1) {
                activateTab(tabSwitcher, activeTab);
            }
        }
    }
});

function activateTab(tabSwitcher, tab) {
    var oldTab = tab.siblings('.tab.active');
    tab.addClass('active');
    oldTab.removeClass('active');

    tabSwitcher.addClass('active');
    tabSwitcher.siblings('a.active').removeClass('active');

    moveSelection(oldTab, tab);
};

function moveSelection(oldTab, newTab) {
    var selection = {}; //

    $('input[name=selection]:checked', oldTab).each(function() {
        var cb = $(this);
        selection[cb.val()] = true;
        cb.prop('checked', false).change();
    });

    $('input[name=selection]', newTab).each(function() {
        var cb = $(this);
        var shouldBeChecked = (cb.val() in selection);
        if(shouldBeChecked != cb.prop('checked')) {
            cb.prop('checked', shouldBeChecked).change();
        }
    });
}

// Old style tabs -- remove this code once we switch over everything to use the new code

$.behaviors('.persistentTabs', function(elt) {
    var cookieName = $(elt).data('persistentTabCookie');
    if(!cookieName) {
        return;
    }
    try {
        var currentValue = cookies.get(cookieName);
        if(currentValue) {
            var activeTab = $(currentValue);
            if(activeTab) {
                var container = activeTab.closest('.tab-content');
                $('.tab-pane', container).removeClass('active');
                activeTab.addClass('active');
            }

            var activeLI = $('[href="' + currentValue + '"], [data-target="' + currentValue + '"]').parent('li');
            if(activeLI) {
                activeLI.siblings('li').removeClass('active')
                activeLI.addClass('active');
            }
        }
    }
    catch (error) {
        console.error(error);
    }
    $('.persistentTab', elt).click(function(evt) {
        var elt = $(this);
        var cookieValue = elt.data('persistentTabValue') || elt.attr('href') || elt.data('target');
        cookies.set(cookieName, cookieValue);
    });
});

